import ClassNames from 'classnames'
import React from 'react'
import {
  TemplateBase
} from './../../base'

export class TemplateForBase extends React.PureComponent {
  render () {
    const {
      className,
      modifierName
    } = this.props

    // props for css classes
    const classes = ClassNames(
      className,
      {'is-modifier-name': modifierName}
    )

    return (
      <TemplateBase
        {...this.props}
        className={classes}
      >
      </TemplateBase>
    )
  }

  static defaultProps = {
    // * If you set new default props, you should create propsType for correct styleguide document.
  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}
